import { render, staticRenderFns } from "./tableSelect.vue?vue&type=template&id=bda43cb4"
import script from "./tableSelect.vue?vue&type=script&lang=js"
export * from "./tableSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bda43cb4')) {
      api.createRecord('bda43cb4', component.options)
    } else {
      api.reload('bda43cb4', component.options)
    }
    module.hot.accept("./tableSelect.vue?vue&type=template&id=bda43cb4", function () {
      api.rerender('bda43cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/curriculum/tableSelect.vue"
export default component.exports